import React, { Component } from 'react';
import { Select } from 'merchant-portal-components';
class ListSearchSelect extends Component {
  state = {
    queryString: '',
    appIdentifier: localStorage.getItem('appIdentifier'),
  };
  handleSearchChange = (queryString) => {
    this.setState({ queryString });
    this.props.changed && this.props.changed(true);
  };

  renderNoOptionsMessage = () => {
    if (this.props.requestingGetListByQuery) {
      return 'Loading...';
    } else {
      return 'No results found';
    }
  };

  returnOptions = () => {
    const {
      listKey,
      allProducts,
      allOffers,
      allCombos,
      allBusinesses,
      allCategories,
    } = this.props;
    if (listKey === 'product') {
      return allProducts ? allProducts : [];
    } else if (listKey === 'offer') {
      return allOffers ? allOffers : [];
    } else if (listKey === 'combo') {
      return allCombos ? allCombos : [];
    } else if (listKey === 'business') {
      return allBusinesses ? allBusinesses : [];
    } else if (listKey === 'category') {
      return allCategories ? formatAllCategories(allCategories) : [];
    } else if (listKey === 'location') {
      return 'select a location';
    }
  };
  allBusinesses;
  getOptionLabel = (option) => {
    const { listKey } = this.props;
    switch (listKey) {
      case 'product':
        return option.name || '';
      case 'combo':
        return option.name || '';
      case 'offer':
        return option.title || option.subtitle || `(${option.label})` || '';
      case 'business':
        return option.display_name || '';
      case 'category':
        return option.name || '';
      case 'location':
        return option.title || '';
    }
  };

  getOptionValue = (option) => {
    const { listKey } = this.props;
    switch (listKey) {
      case 'product':
        return option.id;
      case 'combo':
        return option.id;
      case 'offer':
        return option.offer_id;
      case 'business':
        return option.id;
      case 'category':
        return option.id;
      case 'location':
        return option.id;
    }
  };

  getValue = () => {
    const {
      listKey,
      allProducts,
      allCombos,
      allOffers,
      selectedItem,
      allBusinesses,
      allCategories,
    } = this.props;

    switch (listKey) {
      case 'product':
        return (
          allProducts && allProducts.find(({ id }) => id == selectedItem.id)
        );
      case 'combo':
        return allCombos && allCombos.find(({ id }) => id == selectedItem.id);
      case 'offer':
        return (
          allOffers &&
          allOffers.find((offer) => offer.offer_id === selectedItem.id)
        );
      case 'category':
        return (
          allCategories && allCategories.find(({ id }) => id == selectedItem.id)
        );
      case 'business':
        return (
          allBusinesses && allBusinesses.find(({ id }) => id == selectedItem.id)
        );
    }
  };

  render() {
    const {
      listKey,
      selectedItem,
      selectItem,
      requestingGetProducts,
      requestingGetOffers,
      requestingGetCombos,
      requestingGetCategories,
      light,
    } = this.props;
    const isLoading =
      requestingGetProducts ||
      requestingGetCombos ||
      requestingGetOffers ||
      requestingGetCategories;
    return (
      <Select
        options={this.returnOptions()}
        getOptionValue={(option) => option}
        getOptionLabel={(option) => this.getOptionLabel(option)}
        isLoading={isLoading}
        noOptionsMessage={this.renderNoOptionsMessage()}
        isSearchable={true}
        inputValue={this.state.queryString}
        onChange={(selectedOption) => selectItem(selectedOption)}
        onInputChange={(queryString) => this.handleSearchChange(queryString)}
        value={selectedItem}
        placeholder={
          listKey === 'location'
            ? 'Select a location'
            : `Search ${listKey}${listKey === 'category' ? '' : 's'} by name...`
        }
        light={light}
      />
    );
  }
}

function formatAllCategories(allCategories) {
  let newAllCategories = [];
  allCategories.forEach((element) => {
    if (element.sub_categories?.length > 0) {
      const parentName = element.name;
      element.sub_categories.forEach((subCategory) => {
        newAllCategories.push({
          ...subCategory,
          name: parentName + ' - ' + subCategory.name,
        });
      });
    } else {
      newAllCategories.push(element);
    }
  });
  return newAllCategories;
}

export default ListSearchSelect;
